import { Box, Group, Stack, Text } from '@zorro/web/design-system';
import { CSSProperties, ReactElement } from 'react';

import classNames from './EmployeeLayoutSidebar.module.scss';

export type EmployeeLayoutSidebarSubitemProps = {
  id: string;
  label: string;
  onClick: () => void;
  leftContent?: ReactElement;
  rightContent?: ReactElement;
  isChecked?: boolean;
  description?: string;
  align?: CSSProperties['alignItems'];
  justify?: CSSProperties['justifyContent'];
};

type Props = {
  subitems: EmployeeLayoutSidebarSubitemProps[];
};

export const EmployeeLayoutSidebarSubitem = ({ subitems }: Props) => {
  if (subitems.length === 0) {
    return null;
  }

  return subitems.map(
    ({
      id,
      label,
      description,
      isChecked,
      onClick,
      leftContent,
      rightContent,
      align = 'start',
      justify,
    }) => (
      <Group
        bg={isChecked ? 'zorroPlum.2' : undefined}
        style={{ borderRadius: 8, cursor: 'pointer' }}
        classNames={classNames}
        onClick={onClick}
        align={align}
        wrap="nowrap"
        key={id}
        ml="xl"
        mt="xxs"
        gap="xs"
        py="sm"
        px="md"
        justify={justify}
      >
        {leftContent}
        <Stack gap="0.25rem" mr={justify ? undefined : 'auto'} miw={0}>
          <Text size="sm">{label}</Text>
          {description && (
            <Text c="zorroGray.4" size="xs">
              {description}
            </Text>
          )}
        </Stack>
        {rightContent && <Box style={{ flexShrink: 0 }}>{rightContent}</Box>}
      </Group>
    )
  );
};
